import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MediaRecording } from 'src/app/models/media-recording.model';
import { MeetingRecordDiarizationReadonlyPanelComponent } from '../meeting-record-diarization-readonly-panel/meeting-record-diarization-readonly-panel.component';

@Component({
  selector: 'app-meeting-record-diarization-tab',
  templateUrl: './meeting-record-diarization-tab.component.html',
  styleUrls: ['./meeting-record-diarization-tab.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MeetingRecordDiarizationReadonlyPanelComponent],
})
export class MeetingRecordDiarizationTabComponent {
  is_create = input.required<boolean>();

  media_recordings = input.required<MediaRecording[]>();

  seek_seconds = input<number | null>(null);
}
